import { TextTip } from '@@/Tip/TextTip';

import { RepositoryKind } from '../queries/useAddonRepositoryKind';

const MISMATCH_MESSAGE: Record<'chart' | 'image', string> = {
  chart:
    'This repository holds a container image, not a Helm chart. Set it as the image under Advanced configuration instead.',
  image:
    'This repository holds a Helm chart, not a container image. Set it as the chart source instead.',
};

/**
 * RepositoryKindMismatch warns when the chosen repository holds the other kind of
 * artifact — a chart picked as the image, or the reverse. Nothing in a registry's
 * repository listing says which it is, so this is the only thing that catches the
 * mistake before the install fails.
 *
 * Advisory, not blocking: the answer comes from reading one of the repository's
 * tags, and a registry that will not serve manifests leaves it unknown.
 */
export function RepositoryKindMismatch({
  actual,
  expected,
}: {
  actual?: RepositoryKind;
  /** What the field is for; a mismatch is anything else that is known. */
  expected: 'chart' | 'image';
}) {
  if (!actual || actual === 'unknown' || actual === expected) {
    return null;
  }

  return (
    <TextTip color="orange" className="mt-2">
      {MISMATCH_MESSAGE[expected]}
    </TextTip>
  );
}
